var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user_info_form user_info_form_contact"},[_c('h4',[_vm._v("연락처​")]),_c('p',{staticClass:"description"},[_vm._v("매월 정산 금액 등이 안내됩니다. 연락가능한 번호를 입력해주세요.")]),_c('tel-no-form',{on:{"update":_vm.updateTelNo}}),_c('email-form',{on:{"update":_vm.updateEmail}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }